module.exports = __webpack_public_path__ + "static/media/Peanut.6592a630.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/Peanut.svg
// module id = 1118
// module chunks = 0